import { render, staticRenderFns } from "./AvatarIconMenu.vue.vue?vue&type=template&id=1c5c9108"
import script from "./AvatarIconMenu.vue.vue?vue&type=script&lang=ts"
export * from "./AvatarIconMenu.vue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports